/** @format */

import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  customer_account_Verification,
  messageClear,
} from "../store/reducers/authReducer";

const OtpVerificationForm = ({ customerId }) => {
  const [otp, setOtp] = useState("");
  //const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState(null);

  const navigate = useNavigate();
  const { loader, verifiedMessage, messageError } = useSelector(
    (state) => state.auth,
  );
  const dispatch = useDispatch();

  const handleChange = (e) => {
    const value = e.target.value;
    if (/^\d{0,6}$/.test(value)) {
      setOtp(value);
    }
  };
  /*
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (otp.length !== 6) {
      setMessage("Le code doit contenir 6 chiffres.");
      return;
    }

    setLoading(true);
    setMessage(null);

    try {
      const response = await axios.get(`${process.env.REACT_APP_SERVER_URL}/api/customer/verify/${customerId}/${otp}`);
      setMessage("✅ Vérification réussie !");
      if (onVerified) onVerified(response.data); // Tu peux stocker le token ici
    } catch (error) {
      const errMsg = error?.response?.data?.message || "Erreur lors de la vérification.";
      setMessage(`❌ ${errMsg}`);
    } finally {
      setLoading(false);
    }
  };*/
  //console.log('customer id', customerId)
  //console.log('otp ', otp)
  const handleSubmit = (e) => {
    e.preventDefault();
    if (otp.length !== 6) {
      setMessage("Le code doit contenir 6 chiffres.");
      return;
    }
    // setLoading(true);
    //setMessage(null);
    dispatch(customer_account_Verification({ customerId, otp }));
  };

  useEffect(() => {
    if (verifiedMessage) {
      toast.success(verifiedMessage);
      dispatch(messageClear());
      //navigate('/login');
      navigate("/dashboard");
    }
    if (messageError) {
      toast.error(messageError);
      dispatch(messageClear());
    }
  }, [verifiedMessage, messageError, dispatch, navigate]);

  return (
    <form
      onSubmit={handleSubmit}
      className='max-w-sm mx-auto mt-10 m6-10 p-6 border rounded-xl shadow-lg bg-white space-y-4'
    >
      <h2 className='text-xl font-semibold text-center'>
        Vérification de votre compte
      </h2>
      <h3 className='text-sm font-normal text-start'>
        Consulter votre boite mail, un code de six (6) vous a été envoyer
      </h3>
      <input
        type='text'
        value={otp}
        onChange={handleChange}
        placeholder='Entrez le code à 6 chiffres'
        className='w-full p-3 border rounded-md text-center text-lg tracking-widest'
        maxLength={6}
        inputMode='numeric'
      />

      <button
        type='submit'
        disabled={loader || otp.length !== 6}
        className='w-full bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 rounded-md disabled:opacity-50'
      >
        {loader ? "Vérification..." : "Valider"}
      </button>

      {message && (
        <p className='text-center text-sm text-gray-700'>{message}</p>
      )}
    </form>
  );
};

export default OtpVerificationForm;
